"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allegroBlockTypeNames = exports.AllegroBlockType = void 0;
var AllegroBlockType;
(function (AllegroBlockType) {
    AllegroBlockType[AllegroBlockType["END_OF_OBJECTS"] = 0] = "END_OF_OBJECTS";
    AllegroBlockType[AllegroBlockType["ARC"] = 1] = "ARC";
    AllegroBlockType[AllegroBlockType["FIELD"] = 3] = "FIELD";
    AllegroBlockType[AllegroBlockType["NET_ASSIGNMENT"] = 4] = "NET_ASSIGNMENT";
    AllegroBlockType[AllegroBlockType["TRACK"] = 5] = "TRACK";
    AllegroBlockType[AllegroBlockType["COMPONENT"] = 6] = "COMPONENT";
    AllegroBlockType[AllegroBlockType["COMPONENT_INST"] = 7] = "COMPONENT_INST";
    AllegroBlockType[AllegroBlockType["PIN_NUMBER"] = 8] = "PIN_NUMBER";
    AllegroBlockType[AllegroBlockType["FILL_LINK"] = 9] = "FILL_LINK";
    AllegroBlockType[AllegroBlockType["DRC"] = 10] = "DRC";
    AllegroBlockType[AllegroBlockType["PIN_DEF"] = 12] = "PIN_DEF";
    AllegroBlockType[AllegroBlockType["PAD"] = 13] = "PAD";
    AllegroBlockType[AllegroBlockType["SHAPE_SEG"] = 14] = "SHAPE_SEG";
    AllegroBlockType[AllegroBlockType["FUNCTION_SLOT"] = 15] = "FUNCTION_SLOT";
    AllegroBlockType[AllegroBlockType["FUNCTION_INST"] = 16] = "FUNCTION_INST";
    AllegroBlockType[AllegroBlockType["PIN_NAME"] = 17] = "PIN_NAME";
    AllegroBlockType[AllegroBlockType["XREF"] = 18] = "XREF";
    AllegroBlockType[AllegroBlockType["GRAPHIC"] = 20] = "GRAPHIC";
    AllegroBlockType[AllegroBlockType["SEGMENT_HORIZONTAL"] = 21] = "SEGMENT_HORIZONTAL";
    AllegroBlockType[AllegroBlockType["SEGMENT_DIAGONAL"] = 22] = "SEGMENT_DIAGONAL";
    AllegroBlockType[AllegroBlockType["SEGMENT_VERTICAL"] = 23] = "SEGMENT_VERTICAL";
    AllegroBlockType[AllegroBlockType["NET"] = 27] = "NET";
    AllegroBlockType[AllegroBlockType["PADSTACK"] = 28] = "PADSTACK";
    AllegroBlockType[AllegroBlockType["CONSTRAINT_SET"] = 29] = "CONSTRAINT_SET";
    AllegroBlockType[AllegroBlockType["SI_MODEL"] = 30] = "SI_MODEL";
    AllegroBlockType[AllegroBlockType["PADSTACK_DIM"] = 31] = "PADSTACK_DIM";
    AllegroBlockType[AllegroBlockType["UNKNOWN_0x20"] = 32] = "UNKNOWN_0x20";
    AllegroBlockType[AllegroBlockType["BLOB"] = 33] = "BLOB";
    AllegroBlockType[AllegroBlockType["UNKNOWN_0x22"] = 34] = "UNKNOWN_0x22";
    AllegroBlockType[AllegroBlockType["RATLINE"] = 35] = "RATLINE";
    AllegroBlockType[AllegroBlockType["RECT"] = 36] = "RECT";
    AllegroBlockType[AllegroBlockType["MATCH_GROUP"] = 38] = "MATCH_GROUP";
    AllegroBlockType[AllegroBlockType["CSTRMGR_XREF"] = 39] = "CSTRMGR_XREF";
    AllegroBlockType[AllegroBlockType["SHAPE"] = 40] = "SHAPE";
    AllegroBlockType[AllegroBlockType["PIN"] = 41] = "PIN";
    AllegroBlockType[AllegroBlockType["LAYER_LIST"] = 42] = "LAYER_LIST";
    AllegroBlockType[AllegroBlockType["FOOTPRINT_DEF"] = 43] = "FOOTPRINT_DEF";
    AllegroBlockType[AllegroBlockType["TABLE"] = 44] = "TABLE";
    AllegroBlockType[AllegroBlockType["FOOTPRINT_INST"] = 45] = "FOOTPRINT_INST";
    AllegroBlockType[AllegroBlockType["CONNECTION"] = 46] = "CONNECTION";
    AllegroBlockType[AllegroBlockType["UNKNOWN_0x2F"] = 47] = "UNKNOWN_0x2F";
    AllegroBlockType[AllegroBlockType["STR_WRAPPER"] = 48] = "STR_WRAPPER";
    AllegroBlockType[AllegroBlockType["SGRAPHIC"] = 49] = "SGRAPHIC";
    AllegroBlockType[AllegroBlockType["PLACED_PAD"] = 50] = "PLACED_PAD";
    AllegroBlockType[AllegroBlockType["VIA"] = 51] = "VIA";
    AllegroBlockType[AllegroBlockType["KEEPOUT"] = 52] = "KEEPOUT";
    AllegroBlockType[AllegroBlockType["FILE_REF"] = 53] = "FILE_REF";
    AllegroBlockType[AllegroBlockType["DEF_TABLE"] = 54] = "DEF_TABLE";
    AllegroBlockType[AllegroBlockType["PTR_ARRAY"] = 55] = "PTR_ARRAY";
    AllegroBlockType[AllegroBlockType["FILM"] = 56] = "FILM";
    AllegroBlockType[AllegroBlockType["FILM_LAYER_LIST"] = 57] = "FILM_LAYER_LIST";
    AllegroBlockType[AllegroBlockType["FILM_LIST_NODE"] = 58] = "FILM_LIST_NODE";
    AllegroBlockType[AllegroBlockType["PROPERTY"] = 59] = "PROPERTY";
    AllegroBlockType[AllegroBlockType["KEY_LIST"] = 60] = "KEY_LIST";
})(AllegroBlockType || (exports.AllegroBlockType = AllegroBlockType = {}));
exports.allegroBlockTypeNames = {
    [AllegroBlockType.END_OF_OBJECTS]: "END_OF_OBJECTS",
    [AllegroBlockType.ARC]: "ARC",
    [AllegroBlockType.FIELD]: "FIELD",
    [AllegroBlockType.NET_ASSIGNMENT]: "NET_ASSIGNMENT",
    [AllegroBlockType.TRACK]: "TRACK",
    [AllegroBlockType.COMPONENT]: "COMPONENT",
    [AllegroBlockType.COMPONENT_INST]: "COMPONENT_INST",
    [AllegroBlockType.PIN_NUMBER]: "PIN_NUMBER",
    [AllegroBlockType.FILL_LINK]: "FILL_LINK",
    [AllegroBlockType.DRC]: "DRC",
    [AllegroBlockType.PIN_DEF]: "PIN_DEF",
    [AllegroBlockType.PAD]: "PAD",
    [AllegroBlockType.SHAPE_SEG]: "SHAPE_SEG",
    [AllegroBlockType.FUNCTION_SLOT]: "FUNCTION_SLOT",
    [AllegroBlockType.FUNCTION_INST]: "FUNCTION_INST",
    [AllegroBlockType.PIN_NAME]: "PIN_NAME",
    [AllegroBlockType.XREF]: "XREF",
    [AllegroBlockType.GRAPHIC]: "GRAPHIC",
    [AllegroBlockType.SEGMENT_HORIZONTAL]: "SEGMENT_HORIZONTAL",
    [AllegroBlockType.SEGMENT_DIAGONAL]: "SEGMENT_DIAGONAL",
    [AllegroBlockType.SEGMENT_VERTICAL]: "SEGMENT_VERTICAL",
    [AllegroBlockType.NET]: "NET",
    [AllegroBlockType.PADSTACK]: "PADSTACK",
    [AllegroBlockType.CONSTRAINT_SET]: "CONSTRAINT_SET",
    [AllegroBlockType.SI_MODEL]: "SI_MODEL",
    [AllegroBlockType.PADSTACK_DIM]: "PADSTACK_DIM",
    [AllegroBlockType.UNKNOWN_0x20]: "UNKNOWN_0x20",
    [AllegroBlockType.BLOB]: "BLOB",
    [AllegroBlockType.UNKNOWN_0x22]: "UNKNOWN_0x22",
    [AllegroBlockType.RATLINE]: "RATLINE",
    [AllegroBlockType.RECT]: "RECT",
    [AllegroBlockType.MATCH_GROUP]: "MATCH_GROUP",
    [AllegroBlockType.CSTRMGR_XREF]: "CSTRMGR_XREF",
    [AllegroBlockType.SHAPE]: "SHAPE",
    [AllegroBlockType.PIN]: "PIN",
    [AllegroBlockType.LAYER_LIST]: "LAYER_LIST",
    [AllegroBlockType.FOOTPRINT_DEF]: "FOOTPRINT_DEF",
    [AllegroBlockType.TABLE]: "TABLE",
    [AllegroBlockType.FOOTPRINT_INST]: "FOOTPRINT_INST",
    [AllegroBlockType.CONNECTION]: "CONNECTION",
    [AllegroBlockType.UNKNOWN_0x2F]: "UNKNOWN_0x2F",
    [AllegroBlockType.STR_WRAPPER]: "STR_WRAPPER",
    [AllegroBlockType.SGRAPHIC]: "SGRAPHIC",
    [AllegroBlockType.PLACED_PAD]: "PLACED_PAD",
    [AllegroBlockType.VIA]: "VIA",
    [AllegroBlockType.KEEPOUT]: "KEEPOUT",
    [AllegroBlockType.FILE_REF]: "FILE_REF",
    [AllegroBlockType.DEF_TABLE]: "DEF_TABLE",
    [AllegroBlockType.PTR_ARRAY]: "PTR_ARRAY",
    [AllegroBlockType.FILM]: "FILM",
    [AllegroBlockType.FILM_LAYER_LIST]: "FILM_LAYER_LIST",
    [AllegroBlockType.FILM_LIST_NODE]: "FILM_LIST_NODE",
    [AllegroBlockType.PROPERTY]: "PROPERTY",
    [AllegroBlockType.KEY_LIST]: "KEY_LIST",
};
//# sourceMappingURL=blockType.js.map